export const REMOVED_CONTACTS_API = '/api/dashboard/customer/contact/removed-contacts'
